import React from 'react';
import {connect} from 'react-redux';

import {orderBy} from 'lodash';

import AreasTableAndSearch from './AreasTableAndSearch';
import SensorsTableAndSearch from './SensorsTableAndSearch';
import SystemsTableAndSearch from './SystemsTableAndSearch';
import LinksTableAndSearch from './LinksTableAndSearch';

import TabPanel, { Tab } from '../../components/TabPanel';
import usePermissions from '../../hooks/usePermissions';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './EquipmentItemDataInsert.module.css';

const EquipmentItemDataInsert = (props) => {

    //useEffect(() => {
    //    return () => {
    //        getLinks();
    //    };
    //}, [props.selectedNode]);

    const getLinks = () => {
        props.fetchErpLinks('equipment', {entityId: props.selectedNode.id});
    };

    const isFullArchitectAllowed = usePermissions('architectFull');

    const handleSort = (props, property) => {
        return (event) => {
            props.reorderItems(property);
        };
    };

    const featureFlagForLinksTabs = () => {
        if (process.env.erpAgentEnabled) {
            return (
                <TabPanel
                    aria-label="Equipment Item Options"
                    classes={{
                        root: classes.tabPanel
                    }}
                >
                    <Tab title="Sensors">
                        <SensorsTableAndSearch
                            isFullArchitectAllowed={isFullArchitectAllowed}
                            sensors={props.sensors}
                            order={props.order}
                            orderBy={props.orderBy}
                            handleSort={handleSort}
                            onToggleDeleteSensorModal={props.onToggleDeleteSensorModal}
                            onToggleEditSensorModal={props.onToggleEditSensorModal}
                            onTogglePreviewDataModal={props.onTogglePreviewDataModal}
                            selectedNode={props.selectedNode}
                        />
                    </Tab>
                    <Tab title="Areas Served">
                        <AreasTableAndSearch
                            areas={props.filteredAreas}
                            order={props.order}
                            orderBy={props.orderBy}
                            handleSort={handleSort}
                            selectedNode={props.selectedNode}
                        />
                    </Tab>
                    <Tab title="System Associations">
                        <SystemsTableAndSearch
                            systems={props.filteredSystems}
                            order={props.order}
                            orderBy={props.orderBy}
                            handleSort={handleSort}
                            onToggleDeleteSystemEntityModal={props.onToggleDeleteSystemEntityModal}
                            isFullArchitectAllowed={isFullArchitectAllowed}
                            selectedNode={props.selectedNode}
                        />
                    </Tab>
                    <Tab title="Links">
                        {process.env.erpAgentEnabled &&
                        <LinksTableAndSearch
                            isFullArchitectAllowed={isFullArchitectAllowed}
                            order={props.order}
                            orderBy={props.orderBy}
                            handleSort={handleSort}
                            onToggleCreateLinkModal={props.onToggleCreateLinkModal}
                            onToggleDeleteLinkModal={props.onToggleDeleteLinkModal}
                            selectedNode={props.selectedNode}
                            links={props.links}
                            getLinks={getLinks}
                        />}
                    </Tab>
                </TabPanel>
            );
        } else {
            return (
                <TabPanel
                    aria-label="Equipment Item Options"
                    classes={{
                        root: classes.tabPanel
                    }}
                >
                    <Tab title="Sensors">
                        <SensorsTableAndSearch
                            isFullArchitectAllowed={isFullArchitectAllowed}
                            sensors={props.sensors}
                            order={props.order}
                            orderBy={props.orderBy}
                            handleSort={handleSort}
                            onToggleDeleteSensorModal={props.onToggleDeleteSensorModal}
                            onToggleEditSensorModal={props.onToggleEditSensorModal}
                            onTogglePreviewDataModal={props.onTogglePreviewDataModal}
                            selectedNode={props.selectedNode}
                        />
                    </Tab>
                    <Tab title="Areas Served">
                        <AreasTableAndSearch
                            areas={props.filteredAreas}
                            order={props.order}
                            orderBy={props.orderBy}
                            handleSort={handleSort}
                            selectedNode={props.selectedNode}
                        />
                    </Tab>
                    <Tab title="System Associations">
                        <SystemsTableAndSearch
                            systems={props.filteredSystems}
                            order={props.order}
                            orderBy={props.orderBy}
                            handleSort={handleSort}
                            onToggleDeleteSystemEntityModal={props.onToggleDeleteSystemEntityModal}
                            isFullArchitectAllowed={isFullArchitectAllowed}
                            selectedNode={props.selectedNode}
                        />
                    </Tab>
                </TabPanel>
            );
        }
    };

    return (
        <div className={classes.root}>
            {featureFlagForLinksTabs()}
        </div>
    );
};

const mapStateToProps = state => {
    const {
        filteredAreas,
        filteredSystems,
        links,
        order,
        orderBy: orderByKey,
        selectedNode,
        sensors,
        systems
    } = state.architect;

    return {
        currentScopes:   state.core.currentScopes,
        filteredAreas:   orderBy(filteredAreas, [orderByKey], order),
        filteredSystems: orderBy(filteredSystems, [orderByKey], order),
        links:           orderBy(links, [orderByKey], order),
        order,
        orderBy:         orderByKey,
        selectedNode,
        sensors:         orderBy(sensors, [orderByKey], order),
        systems:         orderBy(systems, [orderByKey], order)
    };
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentItemDataInsert);
